export const waiterReport = {
	tabTitle: "Ranking de Ventas",
	title: "Ventas por empleado",
	description:
		"Informes referentes a las ventas de los bares, los operadores y ranking de productos.",
	filter: "Filtrar por tipo de transacción",
	transactionSell: "Ventas por transacción",
	productSell: "Ventas por producto",
	waiterSell: "Ventas por mesero",
	filename: "ventas-por-mesero",
	filterWaiterLabel: "Nombre del empleado",
	filterWaiterPlaceholder: "Seleccione el(los) empleado(s)",
	deletedEmployee: "Usuario eliminado",
	table: {
		name: "Nombre",
		soldValue: "Valor vendido",
		tip: "Valor en servicio",
		total: "Total",
	},
	sellerTransactionTable: {
		date: "Fecha",
		clients: "Clientes",
		zigCode: "Número de tarjeta",
		products: "Productos",
		refunded: "Reembolsado",
		transactionValue: "Valor de la transacción",
		tip: "Valor de la propina",
		filename: "ventas-por-transaccion",
	},
	sellerProductTable: {
		name: "Nombre",
		category: "Categoría",
		count: "Cantidad",
		value: "Valor",
		discount: "Descuento",
		total: "Total",
		filename: "ventas-por-producto",
	},
};
